module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cartographyList":"Cartography list"},"fr":{"cartographyList":"Liste des cartographies"}}')
  delete Component.options._Ctor
}
